._tags_1f7q9_1 {
  display: flex;
  flex-wrap: wrap;
  gap: 6px; }

@container chat (max-width: 470px) {
  ._tags_1f7q9_1 > * {
    flex-shrink: 0; } }

@container chat (max-width: 470px) {
  ._tags_1f7q9_1 {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none; }
    ._tags_1f7q9_1::-webkit-scrollbar {
      display: none; } }
